module.exports = __webpack_public_path__ + "assets/img/d2.5a0e20a5.jpg";